exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-1d518a00]{height:calc(100vh - 0.93333rem)}", ""]);

// exports
